import { useDispatch, useSelector } from 'react-redux';
import { selectActiveServiceId, selectServiceIds } from '../../../../../../../../selectors/publishTerms';
import { selectIsAutobrokerEnabled } from '../../../../../../../../selectors/auction';
import { EServiceId } from '../../../../../../../../types/reducers/publishTerms';
import { useCallback, useMemo } from 'react';
import { selectPublishTermsService as setPublishTermsService } from '../../../../../../../../actions/publishTerms';

interface IService {
  type: EServiceId;
  selected: boolean;
  blurred: boolean;
  disabled: boolean;
}

interface IUseServices {
  services: IService[];
  selectService: (type: EServiceId) => void;
}

export const useServices = (): IUseServices => {
  const dispatch = useDispatch();
  const servicesIds = useSelector(selectServiceIds);
  const selectedServiceId = useSelector(selectActiveServiceId);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);

  const services = useMemo(() => {
    return servicesIds.map(serviceType => {
      return {
        type: serviceType,
        selected: serviceType === selectedServiceId,
        blurred: false,
        disabled: isAutobrokerEnabled && serviceType === EServiceId.paid,
      };
    });
  }, [isAutobrokerEnabled, selectedServiceId, servicesIds]);

  const handleSelectService = useCallback(
    (serviceId: EServiceId) => {
      dispatch(setPublishTermsService(serviceId));
    },
    [dispatch],
  );

  return { services, selectService: handleSelectService };
};
